export default {
    SET_PARAMETROS: (state, parametros) => {
        state.parametros = {...parametros}
    }
}
